export const truncate = (text, stop, clamp) => {
  if (typeof text === 'undefined' || typeof text !== 'string') {
    return '';
  }
  return text.slice(0, stop) + (stop < text.length ? clamp || '...' : '');
};

export const alphaNum = (string) => {
  return String(string).replace(/[０-９]/g, function (str) {
    return String.fromCharCode(str.charCodeAt(0) - 65248);
  });
};
export const toHankaku = (value) => {
  return String(alphaNum(value))
    .replace(/\u2019/g, '\u0027')
    .replace(/\u201D/g, '\u0022')
    .replace(/\u3000/g, '\u0020')
    .replace(/\uFFE5/g, '\u00A5')
    .replace(/\u301C/g, '\u007E')
    .replace(/\uFF5E/g, '\u007E')
    .replace(
      /[\uFF01\uFF03-\uFF06\uFF08\uFF09\uFF0C-\uFF19\uFF1C-\uFF1F\uFF21-\uFF3B\uFF3D\uFF3F\uFF41-\uFF5B\uFF5D\uFF5E]/g
    );
};
export const amountFormatter = (value) => {
  return toHankaku(value)
    .toString()
    .replace(/,/g, '')
    .replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};
export const applyClassToDigit = (value, classNames) => {
  var wrapper = ['<span class=' + classNames + '>', '</span>'];
  var re = new RegExp('(' + wrapper[0] + ')?(\\d+)(' + wrapper[1] + ')?', 'g');

  return value.replace(re, function (match, p1, p2, p3) {
    if (typeof p1 === 'undefined') {
      p1 = '';
    }
    if (typeof p3 === 'undefined') {
      p3 = '';
    }
    if (p1 != wrapper[0] && p3 != wrapper[1]) {
      return p1 + wrapper[0] + p2 + wrapper[1] + p3;
    } else {
      return match;
    }
  });
};
export const implode = (values, delimiter = ' / ') => {
  return values.join(delimiter);
};
export default {
  truncate,
  alphaNum,
  toHankaku,
  amountFormatter,
  applyClassToDigit,
  implode,
};
